<template>
  <v-container fluid class="ma-0 pa-0">
    <v-row v-if="!editable">
      <v-col cols="auto">
        <div class="tertiary--text text-body-2">
          {{ labelNumberPhone }}
        </div>
        <span class="value secondary--text"> {{ numberPhone }}</span>
      </v-col>
    </v-row>
    <v-row v-if="editable">
      <v-col class="pr-0" cols="5">
        <div class="tertiary--text text-body-2">
          {{
            $t(
              'fleet_management.persons.person_info.labels.card_field_country'
            )
          }}
        </div>
        <v-select
          :id="`idPersonasPais${index}`"
          v-model="countrySelected"
          :items="countries"
          item-text="name"
          item-value="id"
          filled
          dense
          required
          color="tertiary"
        ></v-select>
      </v-col>
      <v-col class="pl-0">
        <div class="tertiary--text text-body-2">
          {{ labelNumberPhone }}
        </div>
        <v-text-field
          type="tel"
          :id="`idPersonasNumero${index}`"
          :placeholder="placeHolderExample"
          v-model="number"
          :error="showErrorMessage"
          :error-messages="numberCheckMessage"
          :rules="[rules.required, rules.length]"
          filled
          dense
          color="tertiary"
          required
          @change="changeNumberCheck"
        ></v-text-field>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { parsePhoneNumberFromString } from 'libphonenumber-js'
import { i18n } from '@leapsight/portal'

const COUNTRY_CODE = {
  argentina: 54,
  chile: 56,
  uruguay: 598
}

export default {
  props: {
    phone: {
      type: Object,
      default: () => {
        return { number: '', index: '' }
      }
    },
    index: Number,
    editable: {
      type: Boolean,
      default: true
    }
  },
  mounted() {
    if (Boolean(this.getCountryId)) {
      this.countrySelected = this.getCountryId
      this.number = this.getNumber.trim()
    }
  },
  data() {
    return {
      number: '',
      labelNumberPhone: i18n.t(
        'fleet_management.persons.new_person.labels.card_field_number'
      ),
      countries: [
        {
          name: 'AR +54',
          id: 54,
          icon: ''
        },
        {
          name: 'CL +56',
          id: 56,
          icon: ''
        },
        {
          name: 'UY +598',
          id: 598,
          icon: ''
        }
      ],
      rules: {
        required: str => !!str || i18n.t(
        'fleet_management.persons.new_person.errors.number_required'
      ),
        length: str =>
          (this.countrySelected == COUNTRY_CODE.argentina
            ? !(str.length !== 10)
            : this.countrySelected == COUNTRY_CODE.chile
            ? !(str.length !== 8)
            : this.countrySelected == COUNTRY_CODE.uruguay
            ? !(str.length !== 8)
            : null) || 'No es un número valido',
        valid: str =>
          (this.countrySelected == COUNTRY_CODE.argentina
            ? (this.valid = /^((\d{2} \d{4})|(\d{3} \d{3})|(\d{4} \d{2})) \d{4}$/gm.test(
                str
              ))
            : this.countrySelected == COUNTRY_CODE.chile
            ? (this.valid = /^((\d{1} \d{4})|(\d{2} \d{3})|(\d{1} \d{4})|(\d{4})) \d{4}$/gm.test(
                str
              ))
            : this.countrySelected == COUNTRY_CODE.uruguay
            ? (this.valid = /^((\d{1} \d{4})|(\d{2} \d{3})|(\d{1} \d{4}))( \d{4}| \d{3})$/gm.test(
                str
              ))
            : null) || i18n.t(
              'fleet_management.persons.new_person.errors.not_number_valid'
            )
      },
      countrySelected: 54
    }
  },
  computed: {
    showErrorMessage() {
      return !this.number
    },
    numberCheckMessage() {
      return !this.$store.state.numberCheck
        ? null
        : i18n.t(
          'fleet_management.persons.new_person.errors.numbers_be_differents'
        )
    },
    getCountryId() {
      const countryCode = this.phone.number.slice(1, 4)
      if (this.countries[2].id === +countryCode) {
        return +countryCode
      }
      // caso que no sea un código de país de uruguay
      return +countryCode.slice(0, 2)
    },
    getNumber() {
      const countryCode = this.phone.number.slice(1, 4)
      if (this.countries[2].id === +countryCode)
        return this.phone.number.slice(4, this.phone.number.length)
      // caso que no sea un teléfono de uruguay
      return this.phone.number.slice(3, this.phone.number.length)
    },
    placeHolderExample() {
      let placeHolder = ''
      if (this.countrySelected === COUNTRY_CODE.argentina)
        placeHolder = '11XXXXXXXX'
      if (this.countrySelected === COUNTRY_CODE.chile)
        placeHolder = '9XXXXXXX / 2XXXXXXX'
      if (this.countrySelected === COUNTRY_CODE.uruguay)
        placeHolder = '96XXXXXX'

      return placeHolder
    },
    numberPhone: {
      get() {
        return this.formatTelephone(this.phone.number)
      },
      set(newVal) {
        this.phone.number = this.parseNumberPhone(newVal)
      }
    }
  },
  methods: {
    changeNumberCheck() {
      this.$store.commit('setNumberCheck', false)
    },
    formatTelephone(phoneNumber) {
      let formattedPhoneNumber = ''
      if (this.countrySelected === 54) {
        formattedPhoneNumber =
          phoneNumber.substring(0, 3) + phoneNumber.substring(3, 13)
      } else if (this.countrySelected === 56) {
        formattedPhoneNumber =
          phoneNumber.substring(0, 4) + phoneNumber.substring(3, 13)
      } else if (this.countrySelected === 598) {
        formattedPhoneNumber =
          phoneNumber.substring(0, 3) + phoneNumber.substring(3, 13)
      }

      const phone = parsePhoneNumberFromString(formattedPhoneNumber)
      if (!phone || !phone.isValid()) {
        return formattedPhoneNumber
      }
      return phone.formatInternational()
    },
    parseNumberPhone(phoneNumber) {
      const phone = parsePhoneNumberFromString(phoneNumber)
      if (!phone || !phone.isValid()) {
        return ''
      }
      return phone.formatNational()
    }
  },
  watch: {
    number: function(newVal) {
      Object.assign(this.phone, {
        number: `+${this.countrySelected}${newVal}`,
        index: this.index
      })
    },
    phone: {
      handler(val) {
        this.countrySelected = this.getCountryId
        this.number = this.getNumber
      },
      deep: true
    }
  }
}
</script>

<style></style>
